import { useTranslation } from 'react-i18next';

import { isNative } from '../../platform/host';
import { APP_VERSION } from '../../version';

/**
 * The build number, and where to get the application.
 *
 * At the bottom of the menu in both of its shapes — the side panel and the
 * phone's sheet — and deliberately the quietest thing on either. The version is
 * of no use at all until something is wrong, and then it is the first thing
 * asked for; the link is of use exactly once per person.
 *
 * The link is hidden inside the application itself. Somebody already holding it
 * does not need to download it, and when there is a newer one the notice at the
 * top of the screen says so.
 */
export function FooterMeta() {
  const { t } = useTranslation();

  return (
    <div className="sidebar__meta">
      {!isNative && (
        <a className="sidebar__apk" href="/app/storageapp.apk" download>
          {t('app.android')}
        </a>
      )}
      <span className="sidebar__version" title={t('app.version', { version: APP_VERSION })}>
        {APP_VERSION}
      </span>
    </div>
  );
}
